import { KycCompletionStatus } from "../../store/store.model";
export function getKycWarning(worksAt, wasKYBApprovedDuringLast5Minutes) {
  const {
    kycCompletionStatus
  } = worksAt || {};
  if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
    return {
      testid: 'kyc-future-requirements',
      text: 'Our payment processor requested a few more details to verify your business. Submit them now to prevent payment delays.'
    };
  } else if (kycCompletionStatus === KycCompletionStatus.Incomplete && !wasKYBApprovedDuringLast5Minutes) {
    return {
      testid: 'onboarding-kyc-error',
      text: 'Our payment processor requested a few more details to verify your business. Submit them now to prevent payment delays.'
    };
  } else {
    return null;
  }
}